// extracted by mini-css-extract-plugin
export default {"negative":"OverallSentimentTrend_negative__6kXNN","positive":"OverallSentimentTrend_positive__hWNEo"};